<template>
  <div :class="['form-group', classe]">
    <label v-if="label" class="small mb-1" :for="id ? id : name">
        <span v-html="label"></span>
        <span v-if="info" class="js-show-tooltip tooltip-info-helper" data-toggle="tooltip" data-placement="top" :title="info">
            <i class="fas fa-info-circle p-color"></i>
        </span>
    </label>
    <input
        :class="['form-control', inputClass, { 'is-invalid': erro }]"
        :id="id ? id : name"
        :name="name"
        :type="type"
        :value="value"
        :placeholder="placeholder"
        :required="required"
        :disabled="disabled"
        :readonly="readonly"
        @change="change"
    />
  </div>
</template>

<script>
export default {
  name: 'InputDate',
  props: {
    classe: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    info: {
      type: String,
      default: '',
    },
    inputClass: {
      type: String,
      default: '',
    },
    erro: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Selecione uma data',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
  },
  data() {
    return {
        data: null,
    };
  },
  methods: {
    change(e) {
        this.data = e.target.value;
        this.$emit('input', this.data);
    },
  }
};
</script>
 